import React, { useContext } from "react";
import "./Services.css";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";

import Card from "../Card/Card";

import { themeContext } from "../../Context";
import { motion } from "framer-motion";

const Services = () => {
  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="services">
      {/* left */}
      <div className="awesome">
        <span style={{ color: darkMode ? "white" : "" }}>My Awesome</span>
        <span>services</span>
        <spane>
          The web is constantly evolving and in order not to fall behind it is{" "}
          <br />
          important to rely on professionals who know how to give you a hand in
          <br />
          exploiting its full potential.
          <br />I am a web developer and I can offer you my expertise in
          creating or
          <br /> restructuring customized websites,To create applications and to
          assist in <br /> correcting visual bugs or malfunctions. <br />I am
          convinced that by entrusting you to me, you will obtain a quality
          service and <br /> that it will enable you to get the most from the
          web. <br />
          Get in touch for more information or a free quote.
        </spane>
        {/* <a href={Resume} download>
          <button className="button s-button">Download CV</button>{" "}
        </a> */}
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <div style={{ left: "14rem" }}>
            <Card
              emoji={HeartEmoji}
              heading={"Design"}
              detail={"Photoshop, Adobe Illustrator"}
            />
          </div>
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <div style={{ top: "12rem", left: "-4rem" }}>
            <Card
              emoji={Glasses}
              heading={"Developer"}
              detail={
                "React, Nodejs, Angular, Next JS, SPRING BOOT, Html, Css, JavaScript "
              }
            />
          </div>
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <div style={{ top: "19rem", left: "12rem" }}>
            {/* <Card
              emoji={Humble}
              heading={"UI/UX"}
              detail={
                "Lorem ispum dummy text are usually use in section where we need some random text"
              }
              color="rgba(252, 166, 31, 0.45)"
            /> */}
          </div>
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
